import React from 'react'
import Subheader from '../../component/Subheader'
import HaldiHead from '../Haldi/HaldiHead';
import HaldiImage from '../Haldi/HaldiImage';
import HaldiBook from '../Haldi/HaldiBook';
import HaldiGallery from '../Haldi/HaldiGallery';
import HaldiCraft from '../Haldi/HaldiCraft';
import HaldiInstagram from '../Haldi/HaldiInstagram';
import HaldiLogoslider from '../Haldi/HaldiLogoslider';
import HaldiService from '../Haldi/HaldiService';

export default function Sangeet() {
    const subheadData = {
      image: '../image/sangeet-banner.webp',
      heading: 'Sangeet Styles: Luxury, Comfort, & Celebration',
      pagename: 'Sangeet',
    }


    const headdata = {
        title: "celebrate the rhythm of sangeet style",
        heading: "Designed For Joyful Movement",
        description:"At Sonam Label, Sangeet fashion comes alive through dynamic silhouettes crafted for effortless movement. Each ensemble merges artisanal craftsmanship with modern elegance, featuring fluid drapes, rhythmic embellishments, and vibrant hues inspired by festive celebration. Designed for comfort, style, and confidence, our Sangeet collection ensures you feel radiant, graceful, and perfectly in sync with every beat of your special night, creating memories that last a lifetime.",
        buttonText: "Learn More",
        link: "/contact",
    };


    const haldiimage = [
        { src: "../image/sangeet-img-1.webp", alt: "sangeet" },
        { src: "../image/sangeet-img-2.webp", alt: "sangeet" },
        { src: "../image/sangeet-img-3.webp", alt: "sangeet" }
    ];


    const haldiService = {
      tagline: "The Sangeet Collection",
      heading: "Graceful Fashion for Festive Nights",
      image: "/image/sangeet-service.webp",
      accordions: [
        {
          title: "Curated Sangeet Looks",
          description:"Our stylists provide personalised guidance on accessories, colours, and finishes to elevate your Sangeet ensemble, ensuring you shine under the vibrant lights."
        },
        {
          title: "Dance-Ready Styling & Accessories",
          description:"Handpicked accessories and jewellery are selected to complement your outfit while allowing freedom of movement for all your dance moments."
        },
        {
          title: "Bride-Focused Silhouettes",
          description:"Silhouettes are tailored for the bride, combining elegance and comfort so you can celebrate freely and feel confident throughout the evening."
        },
        {
          title: "Trousseau Mini-Curation",
          description:"Complete your Sangeet wardrobe with curated pieces that transition beautifully from ceremony to after-party, maintaining cohesive style and festive flair."
        },
        {
          title: "Hand-Crafted Celebration Gifts",
          description:"Thoughtfully curated gifts, hand-packed with care, add meaningful touches to your Sangeet celebrations, reflecting joy, tradition, and celebration."
        },
      ]
    };


    const haldigallery = [
        { src: "../image/sangeetgallery-1.webp"},
        { src: "../image/sangeetgallery-2.webp"},
        { src: "../image/sangeetgallery-3.webp"},
        { src: "../image/sangeetgallery-4.webp"},
        { src: "../image/sangeetgallery-5.webp"},
    ];


    const haldiCraft = {
      heading: "Celebrating Every Sangeet Moment",
      description:"Sangeet style at Sonam Label is designed for movement, joy, and radiant celebration. Each ensemble features hand-embellished fabrics, flowing drapes, and shimmering accents that move gracefully with every beat. Thoughtfully crafted for comfort and confidence, our Sangeet collection ensures you feel luminous, elegant, and beautifully attuned to every special moment of your musical night."
    };


    const haldiInsta = [
      {image: "/image/sangeetinsta-1.webp"},
      {image: "/image/sangeetinsta-2.webp"},
      {image: "/image/sangeetinsta-3.webp"},
      {image: "/image/sangeetinsta-4.webp"},
      {image: "/image/sangeetinsta-5.webp"},
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <HaldiHead headdata={headdata}/>
    <HaldiImage haldiimage={haldiimage}/>
    <HaldiLogoslider/>
    <HaldiService haldiService={haldiService}/>
    <HaldiBook/>
    <HaldiGallery haldigallery={haldigallery}/>
    <HaldiCraft haldiCraft={haldiCraft}/>
    <HaldiInstagram haldiInsta={haldiInsta}/>
    </>
  )
}
